import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from 'src/app/UI/view-models/header/header.component';
import { HeaderBasicComponent } from 'src/app/UI/view-models/header/header-basic/header-basic.component';
import { HeaderFunnelsAndMemberPortalComponent } from 'src/app/UI/view-models/header/header-funnels-and-member-portal/header-funnels-and-member-portal.component';
import { HeaderFinsightsComponent } from 'src/app/UI/view-models/header/header-finsights/header-finsights.component';
import { HeaderSecondaryBrandComponent } from 'src/app/UI/view-models/header/header-secondary-brand/header-secondary-brand.component';
import { HeaderPciComponent } from 'src/app/UI/view-models/header/header-pci/header-pci.component';
import { HeaderCountdownComponent } from 'src/app/UI/view-models/header/header-countdown/header-countdown.component';

import { FooterComponent } from 'src/app/UI/view-models/footer/footer.component';
import { FooterBasicComponent } from 'src/app/UI/view-models/footer/footer-basic/footer-basic.component';
import { FooterFinsightsComponent } from 'src/app/UI/view-models/footer/footer-finsights/footer-finsights.component';
import { FooterUpsellComponent } from 'src/app/UI/view-models/footer/footer-upsell/footer-upsell.component';
import { FooterFunnelsOneStepBasicComponent } from 'src/app/UI/view-models/footer/footer-funnels-one-step-basic/footer-funnels-one-step-basic.component';
import { FooterFunnelsOneStepComponent } from 'src/app/UI/view-models/footer/footer-funnels-one-step/footer-funnels-one-step.component';
import { FooterSecondaryBrandComponent } from 'src/app/UI/view-models/footer/footer-secondary-brand/footer-secondary-brand.component';
import { FooterSecondaryBrandFunnelsComponent } from 'src/app/UI/view-models/footer/footer-secondary-brand-funnels/footer-secondary-brand-funnels.component';
import { FooterDefaultComponent } from 'src/app/UI/view-models/footer/footer-default/footer-default.component';

import { BoardwalkComponent } from 'src/app/UI/view-models/cross-sells/boardwalk/boardwalk.component';
import { BoardwalkV2Component } from 'src/app/UI/view-models/cross-sells/boardwalk-v2/boardwalk-v2.component';
import { HorizonComponent } from 'src/app/UI/view-models/cross-sells/horizon/horizon.component';
import { Header1087Component } from 'src/app/UI/view-models/header/header-1087/header-1087.component';
import { Footer1087Component } from 'src/app/UI/view-models/footer/footer-1087/footer-1087.component';

const SHARED_COMPONENTS = [
    BoardwalkComponent,
    BoardwalkV2Component,
    HorizonComponent
];

const HEADER_COMPONENTS = [
  HeaderComponent,
  HeaderBasicComponent,
  HeaderFunnelsAndMemberPortalComponent,
  HeaderFinsightsComponent,
  HeaderSecondaryBrandComponent,
  HeaderPciComponent,
  HeaderCountdownComponent,
  Header1087Component,
];

const FOOTER_COMPONENTS = [
  FooterComponent,
  FooterBasicComponent,
  FooterFinsightsComponent,
  FooterUpsellComponent,
  FooterFunnelsOneStepBasicComponent,
  FooterFunnelsOneStepComponent,
  FooterSecondaryBrandComponent,
  FooterSecondaryBrandFunnelsComponent,
  FooterDefaultComponent,
  Footer1087Component,
];

@NgModule({
  declarations: [
    ...HEADER_COMPONENTS,
    ...FOOTER_COMPONENTS,
    ...SHARED_COMPONENTS
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule
  ],
  exports: [
    ...HEADER_COMPONENTS,
    ...FOOTER_COMPONENTS,
    ...SHARED_COMPONENTS
  ]
})
export class SharedModule {}